<template>
  <div>
    <v-layout row wrap pt-2>
      <v-flex sm12>
        <v-layout row wrap>
          <v-flex 
            md4 
            pb-2 
            v-for="post in posts" 
            :key="post.id"
            class="pointer"
            @click="goToShowPost(post.slug)" 
          >
            <PostCardProtagonist :post="post" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="spinner">Cargando...</div>
      <div slot="no-more" style="visibility: hidden">No hay más resultados</div>
      <v-layout slot="no-results">
        <v-flex sm12>
          <v-card height="400px">
            <v-layout align-center justify-center row wrap fill-height>
              <v-flex
                sm12
                class="text-29-security text-md-center font-weight-bold"
                style="color: #525252"
              >No hay noticias de esta categoría</v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </infinite-loading>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import PostCardProtagonist from './PostCardProtagonist.vue';
export default {
  components: { PostCardProtagonist },
  props: {
    category: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true 
    }
  },
  data() {
    return {
      page: 1,
      posts: []
    };
  },
  methods: {
    ...mapMutations("products", ["setProduct", "setProducts"]),
    infiniteHandler($state) {
      let url = `/frontend/protagonists`
      let view_as = localStorage.getItem("view_as") || null
      axios.get(url, { 
        params: { 
          page: this.page, 
          category: this.category, 
          view_as: view_as,
          type: this.type
        } 
      })
        .then(({ data }) => {
          if (data.hits.length) {
            this.page += 1;
            this.posts.push(...data.hits);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },
    goToShowPost(slug) {
      this.$router.push({
        name: "post-show",
        params: { slug }
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>

<style>
</style>